import { Component, Input, OnInit, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PAGES } from 'src/app/constants/route.constants';
import { ComponentType } from 'src/app/interfaces/home.interface';
import { AssetLibraryComponent } from 'src/app/pages/asset-library/asset-library.component';
import { ContractualDocsComponent } from 'src/app/pages/contractual-docs/contractual-docs.component';
import { GovernanceMeetingComponent } from 'src/app/pages/governance-meetings/governance-meetings.component';
import { InnovationProductivityPageComponent } from 'src/app/pages/innovation-productivity-page/innovation-productivity-page.component';
import { Meetings } from './modal-wrapper.interface';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss'],
})
export class ModalWrapperComponent implements OnInit {
  
  @ViewChild('customPlaceholder', { read: ViewContainerRef, static: true }) customPlaceholder!: ViewContainerRef;
  @Input() data = {
    clientId: '',
    Url: ''
  };
  title:string = '';
  engagementId:any = "";
  constructor(private route: ActivatedRoute, private router: Router,public viewContainerRef: ViewContainerRef) {}

  fetchDetailComponent(url:string): ComponentType {
    switch (url) {
      case PAGES.ASSET_LIBRARY:
        this.title = 'Asset Library';
        return AssetLibraryComponent;
        break;
        case PAGES.CONTRACTUAL_DOCS:
          this.title = 'Contractual Documents';
         return  ContractualDocsComponent
          break;
        case PAGES.GOVERNANCE_MEETINGS:
          this.title = 'Governance Meeting';
          return GovernanceMeetingComponent
          break;
        case PAGES.INNOVATION_PRODUCTIVITY:
          this.title = 'Innovation and productivity initiatives';
          return InnovationProductivityPageComponent
          break;
      default: return AssetLibraryComponent
        break;
    }
  }
  
  ngOnInit(): void {
    // console.log(this.meeting);
    this.engagementId = this.data.clientId;
    this.loadWidget();
  }
  goto(linkName:any, meeting: Meetings){
    if(this.engagementId != "")
    {
      if(linkName == "Governance Meetings"){
        this.router.navigate([`/governance-meetings`, {id: this.engagementId, meetingId: meeting.uId}]);
      }
    }
    
    
  }
  loadWidget() {
    const component = this.fetchDetailComponent(this.data.Url);
    let compRef =  this.customPlaceholder.createComponent(component);
    compRef.instance.data.clientId = this.data.clientId;
    compRef.instance.data.isModal = true;
  }
}
